/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import { SET_ADVICES } from 'src/redux/actions/advices';


const initialState = {
  advices: []
};

const advicesReducer = (state = initialState, { type, payload }) => ({
  [SET_ADVICES]: () => ({ ...state, ...payload })
}[type] || (() => state))();

export default advicesReducer;
